import HomeHero from "../components/home/HomeHero";
import HomeAboutSchool from "../components/home/HomeAboutSchool";
import HomeAltusAdvantage from "../components/home/HomeAltusAdvantage";
import HomeCurriculums from "../components/home/HomeCurriculums";
import Accreditation from "../components/home/Accreditation";
import HomeSubjectsOffered from "../components/home/HomeSubjectsOffered";
import HomeWhoThrives from "../components/home/HomeWhoThrives";
import HomeStudentsTestimonials from "../components/home/HomeStudentsTestimonials";
import AdmissionProcessSection from "../components/home/AdmissionProcessSection";
import ApplyNowCta from "../components/cta/ApplyNowCta";

function Home() {
  return (
    <div>
      <HomeHero />
      <HomeAboutSchool />
      <HomeAltusAdvantage />
      <HomeWhoThrives />
      <HomeCurriculums />
      <HomeSubjectsOffered />
      <AdmissionProcessSection />
      <ApplyNowCta />
      <HomeStudentsTestimonials />
      <Accreditation />
    </div>
  );
}

export default Home;